

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HeroBar extends Vue {
  @Prop({
    default: true,
  })
  public hasRightVisible!: boolean;
}
